// extracted by mini-css-extract-plugin
export var container = "EditName-module--container--F5Q98";
export var input = "EditName-module--input--FH9UA";
export var title = "EditName-module--title--8-80n";